// src/modules/dashboard/app/LoadDashboard.ts

import { DashboardRepo } from '@/modules/dashboard/domain/DashboardRepo';

type ScreenData = {
  title: string;
  message: string;
  isLoading: boolean;
  dashboardData?: any;
};

export class LoadDashboard {
  repo: DashboardRepo;
  screen_data: ScreenData;

  constructor(repo: DashboardRepo, screen_data: ScreenData) {
    this.repo = repo;
    this.screen_data = screen_data;
  }

  async load() {
    try {
      this.screen_data.isLoading = true;
      const dashboard = await this.repo.loadDashboard();

      // Don't override title and message - let the component handle i18n
      // this.screen_data.title = dashboard.title;
      // this.screen_data.message = dashboard.message;
      this.screen_data.dashboardData = dashboard.dashboardData;

      return this.screen_data;
    } finally {
      this.screen_data.isLoading = false;
    }
  }
}